export default __webpack_public_path__ + "static/media/Avast.d20fa59b.png";